export const getLevels = skills => {
  if (Array.isArray(skills)) {
    const hsks = skills.map(obj => {
      return obj.level;
    });
    return hsks;
  }
  return [];
};